import React from 'react';
import PropTypes from 'prop-types';
import {Dropdown} from 'primereact/dropdown';
import {isArray} from 'lodash';

const StarRatings = [
    {label: '0 Stars'},
    {label: '1 Star'},
    {label: '1 1/2 Stars'},
    {label: '2 Stars'},
    {label: '2 1/2 Stars'},
    {label: '3 Stars'},
    {label: '3 1/2 Stars'},
    {label: '4 Stars'},
];

const starRatingList = ({onChange, value, id}) => (
    <Dropdown
        filter={false}
        filterBy="label,value"
        filterPlaceholder="Select Critic Rating"
        id={id}
        options={
            isArray(StarRatings)
                ? StarRatings.map((rating, index) => ({
                      label: rating.label,
                      value: index,
                  }))
                : []
        }
        showClear={false}
        style={{width: '300px'}}
        value={Number(value)}
        onChange={onChange}
    />
);

starRatingList.propTypes = {
    id: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
};

export default starRatingList;
